import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/database';

const config = {
    apiKey: "AIzaSyDdcbyrgNgrsqWkuOtVnhgdXaVZwHKcVMo",
    authDomain: "ero-advertising.firebaseapp.com",
    projectId: "ero-advertising",
    storageBucket: "ero-advertising.appspot.com",
    messagingSenderId: "925101282001",
    appId: "1:925101282001:web:9c6bae6cc1ea80cac56bf0"
};
export const fire = firebase.initializeApp(config);
